import { FlyoutMenuItemProps } from 'lhs/components/flyout-menu-item';
import { config } from '../../../config/pendo.config.json';
import enUS from '../../../languages/en_US';

export enum AdminToolsPaths {
  COURSES = 'institution-dashboard',
  LEARNING_JOURNEYS = 'learning-journeys',
  LEARNING_ANALYTICS = 'analytics-dashboard',
  LICENSE_ENROLLMENT = 'license-dashboard',
  USER_MANAGEMENT = 'institution-roles',
  SKILL_TAGS = 'skill-tags',
  EMAIL_TEMPLATE = 'institution-email-template',
  ADVANCED_SETTINGS = 'institution-settings',
}

/* @ngInject */
export function getAdminToolsFlyoutItems(
  t: typeof enUS,
  CurrentPermissionsManager,
) {
  const isOrgAdmin = CurrentPermissionsManager.hasOrgAdminPermissions();
  const isCourseManager = CurrentPermissionsManager.hasCourseManagerPermissions();

  let adminToolsFlyoutItems: FlyoutMenuItemProps[] = [
    {
      label: t.INSTITUTIONS.ADMIN_CONTROLS.COURSES(),
      icon: 'course',
      path: AdminToolsPaths.COURSES,
      dataQa: config.pendo.lhs.adminTools.courses,
    },
    {
      label: t.INSTITUTIONS.ADMIN_CONTROLS.LEARNING_JOURNEYS(),
      icon: 'path',
      path: AdminToolsPaths.LEARNING_JOURNEYS,
      dataQa: config.pendo.lhs.adminTools.learningJourneys,
    },
    {
      label: t.INSTITUTIONS.ADMIN_CONTROLS.LEARNING_ANALYTICS(),
      icon: 'data',
      path: AdminToolsPaths.LEARNING_ANALYTICS,
      dataQa: config.pendo.lhs.adminTools.learningAnalytics,
    },
  ];

  if (isOrgAdmin && isCourseManager) {
    adminToolsFlyoutItems = [
      ...adminToolsFlyoutItems,
      {
        label: t.INSTITUTIONS.ADMIN_CONTROLS.LICENSE_AND_ENROLLMENT(),
        icon: 'enrollment',
        path: AdminToolsPaths.LICENSE_ENROLLMENT,
        dataQa: config.pendo.lhs.adminTools.licenseAndEnrollment,
      },
      {
        label: t.INSTITUTIONS.ADMIN_CONTROLS.ORG_LEVEL_USER_MANAGEMENT(),
        icon: 'managing-roles',
        path: AdminToolsPaths.USER_MANAGEMENT,
        dataQa: config.pendo.lhs.adminTools.orgLevelUserManagement,
      },
      {
        label: t.INSTITUTIONS.ADMIN_CONTROLS.SKILL_TAGS(),
        icon: 'skill-tag',
        path: AdminToolsPaths.SKILL_TAGS,
        dataQa: config.pendo.lhs.adminTools.skillTags,
      },
    ];
  }

  adminToolsFlyoutItems = [
    ...adminToolsFlyoutItems,
    {
      label: t.INSTITUTIONS.ADMIN_CONTROLS.EMAIL_TEMPLATE(),
      icon: 'email-template',
      path: AdminToolsPaths.EMAIL_TEMPLATE,
      dataQa: config.pendo.lhs.adminTools.emailTemplate,
    },
    {
      label: t.INSTITUTIONS.ADMIN_CONTROLS.ADVANCED_SETTINGS(),
      icon: 'settings',
      path: AdminToolsPaths.ADVANCED_SETTINGS,
      dataQa: config.pendo.lhs.adminTools.advancedSettings,
    },
  ];

  return adminToolsFlyoutItems;
}

export const adminToolsRelatedPaths = [
  AdminToolsPaths.COURSES,
  AdminToolsPaths.LEARNING_JOURNEYS,
  AdminToolsPaths.LEARNING_ANALYTICS,
  AdminToolsPaths.LICENSE_ENROLLMENT,
  AdminToolsPaths.USER_MANAGEMENT,
  AdminToolsPaths.SKILL_TAGS,
  AdminToolsPaths.EMAIL_TEMPLATE,
  AdminToolsPaths.ADVANCED_SETTINGS,
];

export default getAdminToolsFlyoutItems;
